import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DataService} from '../../services/data.service';
import {UserService} from '../../services/user.service';
import {User} from '../../models/user-model';
import {Router} from '@angular/router';
import {Dialog} from "@angular/cdk/dialog";
import {ForgotPasswordPopupComponent} from "./components/forgot-password/forgot-password-popup.component";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public error: string | undefined;
  public loginForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private shareService: UserService,
    private router: Router,
    private dialog: Dialog
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: false
    });
  }

  ngOnInit(): void {
  }

  public async login() {
    try {
      const login = this.loginForm.value;
      const result = await this.dataService.login(login);

      if (result) {
        const user: User = {
          _id: result['user_id'],
          email: login.email,
          password: login.password,
          id_token: result['id_token'],
          id_refresh_token: result['id_refresh_token'],
          roles: result['roles'],
        };

        this.shareService.setUser(user);
        await this.router.navigate(['/gateway']);
      }
    } catch (e) {
      console.log(e);
      this.error = e;
    }

  }

  public showPasswordForgotten() {
    this.dialog.open(ForgotPasswordPopupComponent);
  }
}
